import React, { memo, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';

import { TFunction } from 'next-i18next';
import { IRelatedProduct } from '../layout';
import { ProductLoop } from './ProductLoop';
import { ArrowLeftIcon, Icon, Image } from '@/components';
import product from '@/features/products/deposit/partials/product';
type NewProductProps = {
  products: IRelatedProduct[];
  t: TFunction;
};
const NewProduct = ({ products, t }: NewProductProps) => {
  const LENGTH = products.length;
  const [indexShow, setIndexShow] = useState<number[]>([0, 1, 2]);
  const [nextDisable, setNextDisable] = useState<boolean>(false);
  const [previewDisable, setPreviewDisable] = useState<boolean>(true);

  const next = () => {
    let max = Math.max(...indexShow);
    if (max === LENGTH - 1) {
      return setNextDisable(true);
    }
    if (max < LENGTH - 1) {
      setIndexShow([indexShow[1], indexShow[2], max + 1]);
      setPreviewDisable(false);
    }
  };
  const preview = () => {
    let min = Math.min(...indexShow);
    if (min === 0) {
      return setPreviewDisable(true);
    }
    if (min > 0) {
      setIndexShow([min - 1, indexShow[0], indexShow[1]]);
      setNextDisable(false);
    }
  };
  return (
    <div className="tw-w-full">
      <div className="tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px]  after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px] tw-h-10">
        <div className="tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2">
          <Image src="/diamond.svg" alt="star" className="tw-h-5 tw-w-5" />
          <span className="tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main">
            Các sản phẩm liên quan
          </span>
          <Image src="/diamond.svg" alt="star" className="tw-h-5 tw-w-5" />
        </div>
      </div>
      <div className="tw-w-max tw-mx-auto tw-mt-10">
        {products.length > 3 ? (
          <div className="tw-relative">
            <div className="tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--left-6 md:tw--left-10">
              {previewDisable ? (
                <div className="tw-opacity-70" key="pre-disable">
                  <Image className="tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10" alt="left" src="/left-light.svg"></Image>
                </div>
              ) : (
                <div onClick={preview} key="pre">
                  <Image
                    className="tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer"
                    alt="left"
                    src="/left-light.svg"
                  ></Image>
                </div>
              )}
            </div>
            <div className="tw-flex tw-justify-center tw-w-full">
              {products.map((p, index) => {
                return (
                  <div
                    key={p.cat_code}
                    className={`${
                      indexShow.includes(index) ? 'tw-block tw-px-2 tw-duration-400' : 'tw-hidden'
                    } tw-w-[248px]`}
                  >
                    <ProductLoop p={p} t={t} />
                  </div>
                );
              })}
            </div>
            <div className="tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--right-6 md:tw--right-10">
              {nextDisable ? (
                <div className="tw-opacity-70" key="next-disabled">
                  <Image className="tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10" alt="right" src="/right-light.svg"></Image>
                </div>
              ) : (
                <div onClick={next} key="next">
                  <Image
                    className="tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer"
                    alt="right"
                    src="/right-light.svg"
                  ></Image>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="tw-w-full tw-flex tw-gap-4 tw-justify-center">
            {products.map((p, key) => (
              <div key={`item-${key}`} className="tw-w-[248px]">
                <ProductLoop p={p} t={t} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(NewProduct);
